
import { merge } from 'lodash'

const HIT_KEY = 'isFromCommonComponent'

const axios = {
  axios: {
    headers: {
      [HIT_KEY]: '1'
    }
  }
}

export const DeptInterface = [
  'hr.department.refactoring.getAllSimpleAsTreeFast',
  'hr.departmentBak.getAllTreeByMonth',
  'hr.department.refactoring.getAllDepartmentLeastAsTreeWithAuth'
]

export function addHeadersIdToHitInterface(url, deptInterface = DeptInterface) {
  const isHit = Array.isArray(deptInterface) && deptInterface.indexOf(url) > -1
  if (isHit) {
    return axios
  } else {
    return {}
  }
}

export function deepMergeAxios(targrt, source) {
  const axios = merge(targrt, source)
  return axios
}



// WEBPACK FOOTER //
// ./src/public/utils/dept-api-code-trace.js